module.exports = __webpack_public_path__ + "img/page10_logo.673dcafe.png";